import { LinearGradient } from "expo-linear-gradient";
import { Button, Text, VStack } from "native-base";
import React from "react";
import { Dimensions, FlatList } from "react-native";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

import RoundedLogo from "@/components/atoms/RoundedLogo";
import EmptyList from "@/components/molecules/EmptyList";
import { formatToCurrency } from "@/utils/helpers";

import { StoreListProps } from "./types";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const { width } = Dimensions.get("window");
const cardWidth = width / 2 - 20;

const StoreList = ({ data, isLoading, onLoadMore, onSelect }: StoreListProps) => {
  return (
    <FlatList
      data={data || Array(6).fill(null)}
      numColumns={2}
      showsVerticalScrollIndicator={false}
      nestedScrollEnabled
      keyExtractor={(item, index) => (item ? item._id : index.toString())}
      onEndReached={onLoadMore}
      onEndReachedThreshold={0.2}
      renderItem={({ item }) => {
        const inactive = item?.status === "Fechado" || item?.fora_da_area;
        return (
          <>
            {isLoading ? (
              <VStack
                w={cardWidth}
                h="180px"
                justifyContent={"center"}
                alignItems={"center"}
                m="2"
                mx="2.5">
                <ShimmerLogo />
                <ShimmerText />
                <ShimmerText />
              </VStack>
            ) : (
              <Button
                flex={0.5}
                mx="10px"
                variant="ghost"
                colorScheme="light"
                onPress={() => onSelect(item?._id)}>
                <VStack w={cardWidth} h="180px" alignItems={"center"} m="2" mx="2.5">
                  <RoundedLogo logoUrl={item.foto_estabelecimento} inactive={inactive} />
                  <VStack opacity={inactive ? 0.4 : undefined} alignItems={"center"} flexShrink={1}>
                    <Text
                      bold
                      fontSize="md"
                      color={"text.600"}
                      mt="10px"
                      noOfLines={2}
                      textAlign="center">
                      {item.nome_fantasia}
                    </Text>
                    <Text color={"text.600"} noOfLines={2} mx="8px">
                      {item.tipo?.nome}
                    </Text>
                    {inactive && (
                      <Text color="red.400">
                        {item.fora_da_area ? "Não atende a região" : "Fechado"}
                      </Text>
                    )}
                    {!inactive && typeof item.valor_frete === "number" && (
                      <Text color={"text.400"} noOfLines={2} mx="8px">
                        Frete:{" "}
                        {item.valor_frete === 0 ? "Grátis" : formatToCurrency(item.valor_frete)}
                      </Text>
                    )}
                  </VStack>
                </VStack>
              </Button>
            )}
          </>
        );
      }}
      ListEmptyComponent={<EmptyList />}
    />
  );
};

const ShimmerLogo = styled(ShimmerPlaceholder)`
  border-radius: 60px;
  width: 80px;
  height: 80px;
`;

const ShimmerText = styled(ShimmerPlaceholder)`
  width: ${cardWidth - 20}px;
  margin-top: 10px;
`;

export default StoreList;
